import React, { useEffect, useMemo, useState, useCallback } from 'react';
import parse from 'html-react-parser';
import '@inovando/react-components/dist/index.css';
import DialogForm from 'components/DialogForm';
import {
  getMoney,
  formatCurrencyIntoNumber,
  isReal,
  ClearString
} from 'utils/transform';
import { validationFieldEnums } from 'utils/constants'
import createDecorator from 'final-form-focus';
import { Form, Field } from 'react-final-form';
import {
  Box,
  Typography,
  useMediaQuery,
  CircularProgress,
} from '@mui/material';
import MUIButton from '@mui/material/Button';
import styled from 'styled-components';
import BulbIcon from 'images/bulb.svg';
import ParcelaField from 'components/ParcelaField';
import { useAuth } from 'contexts/auth';
import { Status } from 'components/DividaItem/styles';
import DocumentIcon from 'images/document.svg';
import { When } from 'react-if';
import { toast } from 'react-toastify';
import { cloneDeep } from 'lodash'
import { BoxInformacaoAdicional2, ContainerBottom } from './styles';
import { IDivida } from 'interfaces/Divida';
import {
  IBuscaOpcaoPagamento,
  IOpcaoPagamento,
  IPersonalizacaoOpcoesPagamento
} from 'interfaces/BuscaOpcaoPagamento';
import { buscaOpcaoPagamentoService } from 'services/buscaOpcaoPagamento/buscaOpcaoPagamento';
import OpcoesPersonalizadas from './OpcoesPersonalizadas'
import { ICustomizacao } from 'interfaces/Customizacao';
import { buscaCustomService } from 'services/buscaCustomizacao/buscaCustomizacao';
import { registrarEventoAsync } from 'services/TrackingService';

interface IOpcoesParcelamentoDialogProps {
  onSubmit: any;
  open: boolean;
  divida: IDivida | null;
  onClose: any;
  opcao: IBuscaOpcaoPagamento;
  opcoesPagamento: IOpcaoPagamento[] | undefined;
  loadingResumo: boolean;
  usaResumoApi: boolean;
  opcaoHandleChange: any;
}

const focusOnErrors = createDecorator();

function OpcoesParcelamentoDialog({
  onSubmit,
  open,
  divida,
  onClose,
  opcao,
  opcoesPagamento,
  loadingResumo,
  usaResumoApi,
  opcaoHandleChange,
}: IOpcoesParcelamentoDialogProps) {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    (!!opcao &&
      !!opcao?.opcoesPagamento &&
      opcao?.opcoesPagamento[0]?.dataVencimento) ||
    null,
  );
  const [recalculaDivida, setRecalculaDivida] = useState('Firmar acordo');
  const [selectOtherOptions, setSelectOtherOptions] = useState(
    'QuantidadeParcela',
  );
  const [loading, setLoading] = useState(false);
  const [valuesValid, setValueValid] = useState({
    quantidadeParcela: true,
    valorParcela: true,
    valorEntrada: true
  });
  const [quantidadeParcela, setQuantidadeParcela] = useState(0);
  const [newOptions, setNewOptions] = useState(opcao);
  const [contratosEscolhidos] = useState(
    divida?.contratos?.map(contrato => contrato?.numero),
  );
  const [entrada, setEntrada] = useState('0,00');
  const [valorParcela, setValorParcela] = useState('0,00');
  const [custom, setCustom] = useState<ICustomizacao>();
  const personalizacaoOpcoesPagamento = useMemo<IPersonalizacaoOpcoesPagamento>(() => {
    return {
      escolherValorEntrada: opcao?.escolherValorEntrada,
      valorEntradaMinima: opcao?.valorEntradaMinima || 0,
      valorEntradaMaxima: opcao?.valorEntradaMaxima || 0,
      escolherDataVencimento: opcao?.escolherDataVencimento,
      permitePerquisarParcelamento: opcao?.permitePerquisarParcelamento,
      listaDataVencimento: opcao?.listaDataVencimento,
      valorParcelaMinima: opcao?.valorParcelaMinima || 0,
      valorParcelaMaxima: opcao?.valorParcelaMaxima || 0,
      quantidadeParcelaMinima: opcao?.quantidadeParcelaMinima || 0,
      quantidadeParcelaMaxima: opcao?.quantidadeParcelaMaxima || 0,
      exibirComboPagamentoTopo: opcao?.exibirComboPagamentoTopo
    }
  }, []);

  const verifyFields = (value: number, validationType: number) => {
    const valuesValidAux = cloneDeep(valuesValid);

    if (validationType === validationFieldEnums.VALOR_PARCELA) {
      valuesValidAux.valorParcela = (value <= personalizacaoOpcoesPagamento.valorParcelaMaxima
        && value >= personalizacaoOpcoesPagamento.valorParcelaMinima) || value === 0
    } else if (validationType === validationFieldEnums.QUANTIDADE_PARCELAS) {
      valuesValidAux.quantidadeParcela = (value <= personalizacaoOpcoesPagamento.quantidadeParcelaMaxima
        && value >= personalizacaoOpcoesPagamento?.quantidadeParcelaMinima) || value === 0;
    } else {
      valuesValidAux.valorEntrada = (value <= personalizacaoOpcoesPagamento.valorEntradaMaxima
        && value >= personalizacaoOpcoesPagamento.valorEntradaMinima) || value === 0;
    }

    setValueValid(valuesValidAux);
  }

  const resetFieldsValid = () => {
    const valuesValidAux = cloneDeep(valuesValid);

    valuesValidAux.quantidadeParcela = true;
    valuesValidAux.valorParcela = true;

    setValueValid(valuesValidAux)
  }

  const handleDateChange = (date: any) => {
    setRecalculaDivida('Recalcular acordo');
    setSelectedDate(date);
  };

  const handleEntradaChange = (entrada: string) => {
    const entradaField = isReal(entrada);
    verifyFields(formatCurrencyIntoNumber(entradaField), validationFieldEnums.VALOR_ENTRADA);
    setEntrada(entradaField);
    setRecalculaDivida('Recalcular acordo');
  };

  const handleValueParcelaChange = (valorParcela: string) => {
    const parcelaField = isReal(valorParcela);
    setValorParcela(parcelaField);
    verifyFields(formatCurrencyIntoNumber(parcelaField), validationFieldEnums.VALOR_PARCELA);
    setRecalculaDivida('Recalcular acordo');
  };

  const handleQuantidadeParcelaChange = (value: number) => {
    verifyFields(Number(value), validationFieldEnums.QUANTIDADE_PARCELAS);
    setQuantidadeParcela(value);
    setRecalculaDivida('Recalcular acordo');
  };

  const { user, bank } = useAuth();
  const isMobile = useMediaQuery((theme: any) =>
    theme?.breakpoints?.down('sm'),
  );

  const SubmitButton = styled(MUIButton)`
    text-transform: none;
  `;

  const showValorTotal = divida?.exibirValorTotal;

  const valorTotalDivida = useMemo(() => {
    return (
      divida?.contratos?.reduce(
        (acc, next): any => acc + Number(next?.valor),
        0,
      ) || 0
    );
  }, [divida]);

  const buscaOpcaoPagamento = useCallback(
    async (e: any) => {
      const modalForm = document.getElementById('form_opcoes');
      try {
        e.preventDefault();
        setLoading(true);

        const { data } = await buscaOpcaoPagamentoService({
          Crm: divida?.crm,
          Carteira: divida?.carteiraId,
          Contrato: usaResumoApi ? null : divida?.numero,
          Contratos: usaResumoApi ? contratosEscolhidos : null,
          CNPJ_CPF: user?.cnpJ_CPF,
          CodigoOpcao: '0',
          DataVencimento: selectedDate ?? null,
          ValorEntrada: isNaN(parseFloat(ClearString(entrada)) / 100) ? null : parseFloat(ClearString(entrada)) / 100,
          ValorParcela: isNaN(parseFloat(ClearString(valorParcela)) / 100) ? null : parseFloat(ClearString(valorParcela)) / 100,
          QuantidadeParcela: quantidadeParcela ?? null,
        });

        if (!!data?.sucesso && !!data?.opcoesPagamento?.length) {
          setNewOptions(data);
          setRecalculaDivida('Firmar acordo');
        } else {
          setNewOptions(opcao);
          if (!!opcao?.listaDataVencimento) {
            setSelectedDate(opcao?.listaDataVencimento[0] as Date);
          }

          setEntrada('0,00');
          setRecalculaDivida('Recalcular acordo');
          if (!!data?.mensagem) toast.error(data?.mensagem);
          else toast.error('Opção de pagamento inválida');
        }
      } finally {
        setLoading(false);
        modalForm?.scroll(0, 100);
      }
    },
    [
      contratosEscolhidos,
      divida,
      entrada,
      opcao,
      quantidadeParcela,
      user,
      selectedDate,
      usaResumoApi,
      valorParcela,
    ],
  );

  useEffect(() => {
    if (!!newOptions?.listaDataVencimento && !selectedDate) {
      setSelectedDate(newOptions?.listaDataVencimento[0]);
    }
    opcaoHandleChange(newOptions);
  }, [newOptions, selectedDate, opcaoHandleChange]);

  useEffect(() => {
    if (!divida || !user) return;
  }, [divida, user]);

  useEffect(() => resetFieldsValid(), [selectOtherOptions]);

  useEffect(() => {
    async function buscaCustomizacao() {
      const { data: newCustom } = await buscaCustomService({
        crms: divida?.crm,
        carteiraId: divida?.carteiraId
      })
      setCustom(newCustom);
    }
    buscaCustomizacao();
  }, []);

  const Title = () => {
    return (
      <Box
        display="flex"
        alignItems={isMobile ? 'flex-start' : 'center'}
        p={3}
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex" alignItems="center">
            <Box mr={2}>
              <Status color="primary">
                <strong>Dívida ativa</strong>
              </Status>
            </Box>
            <Box mr={1}>
              <img
                style={{ marginBottom: 2 }}
                src={DocumentIcon}
                alt="Documento"
              />
            </Box>
            <Status>
              <span>
                {divida?.contratos?.length} Contrato
                {Number(divida?.contratos?.length) > 1 && 's'}
              </span>
            </Status>
          </Box>
          <Typography style={{ fontSize: 28 }} variant="h6">
            <strong>{!!bank && bank?.financeira}</strong>
          </Typography>
        </Box>
        {showValorTotal && (
          <Box>
            <Box
              display="flex"
              flexDirection={isMobile ? 'row' : 'column'}
              flexWrap="wrap"
              alignItems="flex-end"
            >
              <Box mr={isMobile ? 2 : 0}>
                <Typography variant="body2">Valor total da dívida</Typography>
              </Box>
              <Typography variant="body1" color="primary">
                {getMoney(valorTotalDivida)}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <div>
      <DialogForm onClose={onClose} open={open} title={<Title />} id="form_opcoes">
        {() => (
          <Form
            onSubmit={recalculaDivida === 'Firmar acordo' && onSubmit}
            decorators={[focusOnErrors]}
            initialValues={{
              parcelamento: !!opcoesPagamento && opcoesPagamento[0],
              DataValidade:
                !!opcoesPagamento && opcoesPagamento[0]?.dataVencimento,
              ValorEntrada:
                !!opcoesPagamento && opcoesPagamento[0]?.valorParcela,
              novaOpcao: opcao,
            }}
            render={({ handleSubmit, submitting, values }: any) => {
              values.DataValidade =
                values?.parcelamento?.dataVencimento || selectedDate;
              return (
                <form onSubmit={handleSubmit} noValidate>

                  {!!custom?.OpcoesPagamentoTop && (divida?.tipoContrato !== "RENEG") && (
                    <Box>
                      {parse(custom?.OpcoesPagamentoTop)}
                    </Box>
                  )}

                  <Box mt={3} mb={3}>
                    <Typography> Clique sobre a opção para escolher</Typography>
                  </Box>
                  <Box style={{ marginBottom: '50px' }}>
                    <When condition={!!opcao?.exibirComboPagamentoTopo}>
                      <OpcoesPersonalizadas
                        selectedDate={selectedDate}
                        handleDateChange={handleDateChange}
                        entrada={entrada}
                        handleEntradaChange={handleEntradaChange}
                        selectOtherOptions={selectOtherOptions}
                        setSelectOtherOptions={setSelectOtherOptions}
                        valorParcela={valorParcela}
                        setValorParcela={setValorParcela}
                        quantidadeParcela={quantidadeParcela}
                        setQuantidadeParcela={setQuantidadeParcela}
                        handleQuantidadeParcelaChange={handleQuantidadeParcelaChange}
                        handleValueParcelaChange={handleValueParcelaChange}
                        personalizacaoOpcoesPagamento={personalizacaoOpcoesPagamento}
                        valuesValid={valuesValid}
                      />
                    </When>
                    {!loading && (
                      <Field
                        component={ParcelaField as any}
                        name="parcelamento"
                        opcao={opcao}
                        options={newOptions?.opcoesPagamento ?? opcoesPagamento}
                        divida={divida}
                      />
                    )}
                    <When condition={!opcao?.exibirComboPagamentoTopo}>
                      <OpcoesPersonalizadas
                        selectedDate={selectedDate}
                        handleDateChange={handleDateChange}
                        entrada={entrada}
                        handleEntradaChange={handleEntradaChange}
                        selectOtherOptions={selectOtherOptions}
                        setSelectOtherOptions={setSelectOtherOptions}
                        valorParcela={valorParcela}
                        setValorParcela={setValorParcela}
                        quantidadeParcela={quantidadeParcela}
                        setQuantidadeParcela={setQuantidadeParcela}
                        handleQuantidadeParcelaChange={handleQuantidadeParcelaChange}
                        handleValueParcelaChange={handleValueParcelaChange}
                        personalizacaoOpcoesPagamento={personalizacaoOpcoesPagamento}
                        valuesValid={valuesValid}
                      />
                    </When>
                  </Box>
                  <ContainerBottom my={2}>
                    {!!loadingResumo ||
                      !!submitting ||
                      (!!loading && (
                        <Box
                          width="100%"
                          display="flex"
                          justifyContent="center"
                        >
                          <CircularProgress />
                        </Box>
                      )) || (
                        <>
                          {recalculaDivida === 'Firmar acordo' ? (
                            <SubmitButton
                              variant="contained"
                              color="primary"
                              fullWidth
                              type="submit"
                              onClick={handleSubmit}
                              disabled={
                                !(valuesValid.quantidadeParcela &&
                                  valuesValid.valorEntrada &&
                                  valuesValid.valorParcela) ||
                                submitting
                              }
                              size="small"
                            >
                              <span>
                                {values.parcelamento.precisaDeAprovacao
                                  ? 'Enviar Acordo'
                                  : recalculaDivida}
                              </span>
                            </SubmitButton>
                          ) : (
                            <SubmitButton
                              variant="contained"
                              color="primary"
                              fullWidth
                              disabled={
                                !(valuesValid.quantidadeParcela &&
                                  valuesValid.valorEntrada &&
                                  valuesValid.valorParcela) ||
                                loading
                              }
                              onClick={e => buscaOpcaoPagamento(e)}
                              size="small"
                            >
                              <span>
                                {values.parcelamento.precisaDeAprovacao
                                  ? 'Enviar Acordo'
                                  : recalculaDivida}
                              </span>
                            </SubmitButton>
                          )}
                        </>
                      )}
                  </ContainerBottom>

                  <Box
                    my={3}
                    display="none"
                    alignItems="center"
                    style={{
                      maxWidth: 300,
                    }}
                  >
                    <img src={BulbIcon} alt="Dica" />

                    <Box ml={2}>
                      {' '}
                      <Typography
                        color="secondary"
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        Dica
                      </Typography>
                      <Typography variant="body2">
                        Quanto menor o número de parcelas, mais desconto podemos
                        oferecer
                      </Typography>
                    </Box>
                  </Box>

                  {!!custom?.InformacaoAdicional2 && (
                    <BoxInformacaoAdicional2>
                      {parse(custom?.InformacaoAdicional2)}
                    </BoxInformacaoAdicional2>
                  )}
                </form>
              );
            }}
          />
        )}
      </DialogForm>
    </div>
  );
}

export default OpcoesParcelamentoDialog;
